/**
 * Created by cd01 on 2018/1/20.
 */
{
    angular.module('interfaceModule')
        .controller('StationMapController',StationMapController);
    StationMapController.$inject=['$scope','$stateParams',"requestHandler",'utils.constant','md5','ModalWindow','alertControl','$state'];
    function StationMapController($scope,$stateParams,requestHandler,constant,md5,ModalWindow,alertControl,$state){
        let vm=this;
        let collect={


        };
        vm.collect=collect;

        active();
        function active() {
            console.log('用户', $stateParams.userId);
        }
    }
}